import getAuthenticationServiceClient from "./getAuthenticationServiceClient";

export default async function getMISSignInToken(idToken: string) {
  return getAuthenticationServiceClient().getMISSignInToken(idToken);
}
